import { coloringRuleOperator } from 'shared/constants.json';

const operators = {
  [coloringRuleOperator.greaterThan]: (a, b) => a > b,
  [coloringRuleOperator.greaterThanOrEqual]: (a, b) => a >= b,
  [coloringRuleOperator.lessThan]: (a, b) => a < b,
  [coloringRuleOperator.lessThanOrEqual]: (a, b) => a <= b,
  [coloringRuleOperator.equal]: (a, b) => a === b,
};

export function evaluateColoringRules(value, rules) {
  if (value === null || value === undefined || !Array.isArray(rules) || rules.length === 0) {
    return null;
  }

  const match = rules.find((rule) => {
    const fn = operators[rule.operator];
    return fn && fn(value, rule.value);
  });

  return match ? (match.color || 'default') : null;
}
